import React, { Component, cloneElement,useState } from 'react';
import { List, CreateButton, SelectInput, ReferenceInput, RefreshButton, TopToolbar, Datagrid, TextField, DateField, ShowButton, Filter,usePermissions,useResourceContext, TextInput, EditButton, ExportButton, Link , Button ,useRecordContext ,DateInput, TimeInput } from 'react-admin';
// import { DateInput, TimeInput } from 'react-admin-date-inputs';
// import { Accordion } from '@mui/material';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import Modal from 'react-responsive-modal';import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import Swal from 'sweetalert2';
import { useLocation,useNavigate } from 'react-router-dom';
import GetAppIcon from '@mui/icons-material/GetApp';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationsIcon from '@mui/icons-material/Notifications';

const Filters = (props) => (
    <Filter {...props}>
        <TextInput label="Popup Text" source="popup_text" />
        <TextInput label="Survey Type" source="survey_type" />
        <ReferenceInput label="Targeted Feature" source="survey_targeted_feature_id" reference="survey_targeted_features">
            <SelectInput optionText="targeted_feature" />
        </ReferenceInput>
        <DateInput label="Start date" source="start_date" />
        <DateInput label="End date" source="end_date" />
        <TimeInput label="Start Time" source="start_time" />
        <TimeInput label="End Time" source="end_time" />
    </Filter>
);


const textFieldStyle = {
    display: 'block',
    width: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

};


const ListActions = (props) => {

  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
    );


  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log('...', location.pathname, `${apiUrl}/${resource}_csv`)
    options.method = 'GET';
    let _url = location.pathname.split('?');
    if (_url.length > 1 && _url[1] !== '') {
      console.log('params found');
     setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
          .then(res => {
            return res.json();
          }).then(jsonD => {
            console.log('json= inside callback', jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : '';
            Swal.fire({
              html: msg,
              icon: 'success',
            })
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
    } else {
      setCustomFilterUrl(location.search)
      fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
          .then(res => {
            return res.json();
          }).then(jsonD => {
            console.log('json= inside callback', jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : '';
            Swal.fire({
              html: msg,
              icon: 'success',
            })
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
    }
  }
  const exporterModal = () => {
    return ''
  }

  const onClose = () => {
    setModalShow(false);
  }
    const { filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
    const csvResource = resource + '_csv'
    return (
      <React.Fragment>
        <TopToolbar>
          {filters && cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
          })}
          <RefreshButton />
          {/* <ExportButton
        onClick={(e) => this.callExport(e)}
        disabled={total === 0}
        resource={csvResource}
        sort={currentSort}
        filter={{ ...filterValues, ...permanentFilter }}
        exporter={this.exporterModal}
        maxResults={maxResults}
        /> */}
          <div>
            <button className="export-button"
              onClick={(e) => callExport(e)}
              disabled={total === 0}
              sort={currentSort}
              filter={{ ...filterValues, ...permanentFilter }}
            >
              {<GetAppIcon />}
              <span>Export</span>
            </button>
          </div>
          {/* <CreateButton /> */}
        </TopToolbar>
        {
          modalShow &&
          <Modal open={modalShow} onClose={onClose} center>
            <h3>{modalMsg}</h3>
          </Modal>
        }
      </React.Fragment>
    )
}


const CloneSurveyButton = () => 
    {
      const record = useRecordContext();
      return(
        <Button
            component={Link}
            to={{
                pathname: '/surveys/create',
                search: `?source=%7B"id"%3A"${record.id}"%2C"total_count"%3A1%7D`,
            }}
            onClick={e=>e.stopPropagation()}
        >
            <span>{<FileCopyIcon className="clone-img" />}<span className="clone-text">Duplicate</span></span> 
        </Button>

      )
    };


    const NotificationList = (props) => {
    const { permissions } = usePermissions();
    const record = useRecordContext();
    const navigate = useNavigate();
    
    const [chatList, setChatList] = useState([]);
    const [range, setRange] = useState([0, 9]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const todayDate = new Date().getDate() + '/' + (new Date().getMonth() + 1) +  '/' + new Date().getFullYear();
    const previousDate = new Date().getDate() - 1 + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear();

    React.useEffect(()=>{
      fetchNotificationList(range);
    },[])    

    const fetchNotificationList = (newRange) => {
      // if (loading) return;      
      setLoading(true);
      const apiUrl = RUN_TIME_API_ENDPOINT;
      const options = CommonHeaderOption();
      options.method = "GET";
      const rangeQuery = JSON.stringify(newRange);
      // options.body = JSON.stringify(postData);
      fetch(`${apiUrl}/chat_list?range=${rangeQuery}`, options)
        .then((res) => {
          if (res.ok) return res.json();
          return res.json().then((res) => {
            throw new Error(res.message);
          });
        })
        .then((response) => {
          console.log("respomse heree", response);
          if (response.data.length === 0) {
            setHasMore(false);
          } else {
            setChatList(prevData => [...prevData, ...response.data]);
            // setRange([range[1], range[1] + 10]);
          }
        })
        .catch((err) => {
          console.log("err==", err);
          setLoading(false);
        });
    }
    
    const handleLoadMore = () => {
      console.log('load mire ');
      if (hasMore) {
        setRange([range[1], range[1] + 10]);
        fetchNotificationList([range[1], range[1] + 10]);
      }
    };

    const redirectToOrder = (e,chat) => {
      console.log('....',chat);
      e.preventDefault();
      let data = [{"id":chat?.id,"type":chat?.type,"push_notification_id":chat?.push_notification_id}]
  
      const apiUrl = RUN_TIME_API_ENDPOINT;
      const options = CommonHeaderOption();
      options.method = 'POST';
      options.body = JSON.stringify({ data });
  
      return fetch(`${apiUrl}/mark_as_read`, options)
      .then(res => {
        return res.json();
      })
      .then(json => {
        console.log('data',json);
        chat?.sap_digital_order_id !=undefined && navigate(`/sap_digital_app_orders/${chat?.sap_digital_order_id}/show/3`)
      }).catch(error => {
          console.log(error);
      })
    } 



  const groupDataByDate = (data) => {
    return data.reduce((acc, item) => {
      // const date = new Date(item.created_at).toLocaleDateString();
      const date = moment(item.created_at).format('DD MMM YYYY')
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    }, {});
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
  
    const diffTime = Math.abs(now - date);
    const diffMinutes = Math.floor(diffTime / (1000 * 60));
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
    if (diffDays > 0) {
      // If the message is from previous days, show days ago
      return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    } else if (diffHours > 0) {
      // If the message is from today but more than 1 hour ago, show hours ago
      return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    } else {
      // If the message is less than 1 hour ago, show minutes ago
      return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
    }
  };

  const groupedData = groupDataByDate(chatList);
  // const sortedDates = Object.keys(groupedData).sort((a, b) => moment(b, 'DD MMM YYYY').diff(moment(a, 'DD MMM YYYY')));


  // console.log('groupedData',sortedDates);

    return (
        <React.Fragment>
            <Scrollbars
             className="scroll-container"
             >
                <List 
                {...props} 
                // sort={{ field: 'created_at', order: 'DESC' }} filters={<Filters />} 
                title="Notification List" 
                exporter={false}
                pagination={false}
                // actions={<ListActions  props={props} />}
                >
                    {/* <div className="row-space-between row-align-center nm-header">
                      <div className="notification-txt">Notification</div>
                      <div className="row-align-center pointer-cursor">
                        <div className="dismiss-txt">Dismiss all</div>
                        <img src="assets/icons/close-circle.svg" alt="" />
                      </div>
                    </div> */}

                    <div id="root1" className="notification-list">

                      {
                        Object.keys(groupedData).sort((a, b) => moment(b, 'DD MMM YYYY').diff(moment(a, 'DD MMM YYYY'))).map(date => (
                        // Object.keys(groupedData).map(date => (
                          <div key={date}>
                                  <div>
                                    <div className="notification-day-date">{date}</div>
                                  </div>
                              {groupedData[date].map((chat, index) => (
                                <div key={chat?.id} onClick={(e)=>redirectToOrder(e,chat)}>
      
                                  <div className="notification-read">
                                    <div>
                                      <div className="notification-bell">
                                        {
                                          chat?.read_status ?
                                          <NotificationsNoneIcon />
                                          :
                                          <NotificationsIcon/>
                                        }
                                      </div>
                                    </div>
                                    <div className="flex-one">
                                      <div className="row-space-between">
                                        <div className="noti-title">{chat?.title}</div>
                                        {/* <div className="noti-time">{moment(chat?.created_at).format('hh:mm')}</div> */}
                                        <div className="noti-time">{formatTimestamp(chat?.created_at)}</div>
                                      </div>
                                      <div className="notification-description">{chat?.description}</div>
                                    </div>
                                  </div>
                                </div>
                              ))}

                          </div>
                        ))
                      }
                      {hasMore &&  (
                        <button  className="lm-btn" onClick={handleLoadMore}>Load More</button>
                      )}
                    </div>
                </List>
            </Scrollbars>

        </React.Fragment>
    )
}


export default NotificationList;